import {customElement} from "lit/decorators.js";
import {css, html, LitElement, TemplateResult} from "lit";
import {GameCanvas} from "./GameCanvas";

@customElement("puzzle-game")
export class Puzzel extends LitElement {
    public static styles = css`
        .modal {
            position: fixed;
            z-index: 100;
            background-color: rgba(0, 0, 0, 0.5);
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            overflow: auto;
            display: none;
            justify-content: center;
            align-items: center;
            font-family: "onesize";
        }

        .modal-content {
            margin: 5% 0 0 0;
            padding: 14px;
            border: 1px solid #888;
            width: 80%;
            height: fit-content;
            background-color: white;
        }

        .alert {
            display: none;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            padding: 10px 20px;
            z-index: 9999;
            min-width: 60%;
            text-align: center;
        }

        .alert h1 {
            margin-bottom: auto;
        }

        .alert p {
            margin-block: 0;
            margin-bottom: 1em;
        }

        .puzzle {
            display: flex;
            flex-direction: column;
            align-items: center;
            background-color: #313638;
        }

        .board {
            position: relative;
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            gap: 15px;
            margin-top: 20px;
        }

        .dropBox {
            position: relative;
            width: 200px;
            height: 200px;
            background-color: white;
            display: flex;
            align-items: center;
            justify-content: center;
            background-position: center;
            color: black;
        }

        .drag {
            position: relative;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-wrap: wrap;
            gap: 10px;
            margin: 0 50px;
        }

        .dragBox {
            position: relative;
            width: 100px;
            height: 100px;
            background-color: transparent;
            text-align: center;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            overflow: hidden;
        }

        .images {
            position: relative;
            width: 100%;
            height: 100%;
            background: var(--img);
            background-size: cover;
        }

        button {
            padding: 5px 15px;
            border: none;
            cursor: pointer;
            margin: 10px 0;
            font-size: 1.5em;
            font-family: 'Onesize';
        }

        .image-input {
            width: 100%;
            height: 50px;
            background-color: transparent;
            border: solid black 2px;
            position: absolute;
            text-align: center;
            font-size: 50px;
            font-family: "onesize";
        }

        .incorrect {
            border: 2px solid red;
            color: red;
        }

        .correct {
            border: 2px solid green;
            color: green;
        }

        .instructions {
            font-size: 20px;
            margin: 5px 0;
        }
    `;

    protected updated(): void {
        this.handlePuzzleInput();
    }

    protected render(): TemplateResult {
        // noinspection CssUnknownTarget
        return html`
            <section class="modal">
                <div class="modal-content">
                    <div class="alert"></div>
                    <div class="puzzle">
                        <section class="board" id="board">
                            <div class="dropBox" id="1">1</div>
                            <div class="dropBox" id="2">2</div>
                            <div class="dropBox" id="3">3</div>
                            <div class="dropBox" id="4">4</div>
                            <div class="dropBox" id="5">5</div>
                            <div class="dropBox" id="6">6</div>
                            <div class="dropBox" id="7">7</div>
                            <div class="dropBox" id="8">8</div>
                            <div class="dropBox" id="9">9</div>
                        </section>

                        <p class="instructions">Number the pieces below to indicate their correct positions.</p>

                        <section class="drag" id="drag">
                            <div class="dragBox">
                                <div class="images" id="block7" style="--img: url('/assets/puzzel/7.png')"></div>
                                <input type="number" min="0" max="9" placeholder="..." class="image-input">
                            </div>

                            <div class="dragBox">
                                <div class="images" id="block4" style="--img: url('/assets/puzzel/4.png')"></div>
                                <input type="number" min="0" max="9" placeholder="..." class="image-input">
                            </div>

                            <div class="dragBox">
                                <div class="images" id="block2" style="--img: url('/assets/puzzel/2.png')"></div>
                                <input type="number" min="0" max="9" placeholder="..." class="image-input">
                            </div>

                            <div class="dragBox">
                                <div class="images" id="block1" style="--img: url('/assets/puzzel/1.png')"></div>
                                <input type="number" min="0" max="9" placeholder="..." class="image-input">
                            </div>

                            <div class="dragBox">
                                <div class="images" id="block9" style="--img: url('/assets/puzzel/9.png')"></div>
                                <input type="number" min="0" max="9" placeholder="..." class="image-input">
                            </div>

                            <div class="dragBox">
                                <div class="images" id="block3" style="--img: url('/assets/puzzel/3.png')"></div>
                                <input type="number" min="0" max="9" placeholder="..." class="image-input">
                            </div>

                            <div class="dragBox">
                                <div class="images" id="block6" style="--img: url('/assets/puzzel/6.png')"></div>
                                <input type="number" min="0" max="9" placeholder="..." class="image-input">
                            </div>

                            <div class="dragBox">
                                <div class="images" id="block5" style="--img: url('/assets/puzzel/5.png')"></div>
                                <input type="number" min="0" max="9" placeholder="..." class="image-input">
                            </div>

                            <div class="dragBox">
                                <div class="images" id="block8" style="--img: url('/assets/puzzel/8.png')"></div>
                                <input type="number" min="0" max="9" placeholder="..." class="image-input">
                            </div>
                        </section>
                        <button class="check" @click="${this.checkOrder}">Check</button>
                    </div>
                </div>
            </section>
        `;
    }

    private handlePuzzleInput(): void {
        const inputs: NodeListOf<HTMLInputElement> = this.shadowRoot?.querySelectorAll<HTMLInputElement>(".image-input") as NodeListOf<HTMLInputElement>;
        inputs?.forEach(input => {
            if (input.hasAttribute("data-has-listener")) return;

            let previousValue: string | null = null;

            input.addEventListener("input", (event) => {
                const inputField: HTMLInputElement = event.target as HTMLInputElement;
                const value: string = inputField.value;

                this.clearPreviousImage(inputs, inputField, previousValue);
                this.clearOtherImage(inputs, inputField, value);
                this.updateImage(inputField, value);

                previousValue = value;
            });

            input.setAttribute("data-has-listener", "true");
        });
    }

    private clearPreviousImage(inputs: NodeListOf<HTMLInputElement>, inputField: HTMLInputElement, previousValue: string | null): void {
        if (!previousValue) return;
        const otherInput: HTMLInputElement | undefined = Array.from(inputs).find(other => other !== inputField && other.value === previousValue);
        if (!otherInput) this.clearImage(previousValue);
    }

    private clearOtherImage(inputs: NodeListOf<HTMLInputElement>, inputField: HTMLInputElement, value: string): void {
        const otherInput: HTMLInputElement | undefined = Array.from(inputs).find(other => other !== inputField && other.value === value);
        if (otherInput) {
            otherInput.value = "";
            this.clearImage(value);
        }
    }

    private clearImage(id: string): void {
        const dropBox: HTMLElement | null = this.shadowRoot?.getElementById(id) as HTMLElement | null;
        if (dropBox) dropBox.style.backgroundImage = "";
    }

    private updateImage(inputField: HTMLInputElement, value: string): void {
        const image: Element | null = inputField.previousElementSibling;
        const dropBox: HTMLElement | null | undefined = this.shadowRoot?.getElementById(value);

        if (image && dropBox) {
            const imageNumber: string = image.id.slice(5);
            dropBox.style.backgroundImage = `url(/assets/puzzel/${imageNumber}.png)`;
        }
    }

    private checkOrder(): void {
        const dropBoxes: HTMLElement[] = Array.from(this.shadowRoot?.querySelectorAll<HTMLElement>(".dropBox") || []);
        let correctCount: number = 0;

        dropBoxes.forEach(dropBox => {
            dropBox.classList.remove("incorrect", "correct");

            const urlMatch: RegExpMatchArray | null = dropBox.style.backgroundImage.match(/\/(\d+)\.png/);

            if (urlMatch && urlMatch[1] === dropBox.id) {
                dropBox.classList.add("correct");
                correctCount++;
            } else {
                dropBox.classList.add("incorrect");
            }
        });

        correctCount === dropBoxes.length ? this.puzzleSolved() : this.incorrectOrderAlert();
    }

    private incorrectOrderAlert(): void {
        const alert: HTMLElement = this.shadowRoot?.querySelector<HTMLElement>(".alert") as HTMLElement;
        if (!alert) return;
        alert.style.display = "block";
        alert.style.backgroundColor = "rgba(255, 0, 0, 0.9)";
        alert.innerHTML = "<h1>Incorrect Order</h1><br><p>Try again.</p>";
        setTimeout(() => alert.style.display = "none", 1500);
    }

    private puzzleSolved(): void {
        const board: HTMLElement = this.shadowRoot?.getElementById("board") as HTMLElement;
        const alert: HTMLElement = this.shadowRoot?.querySelector<HTMLElement>(".alert") as HTMLElement;

        if (board) {
            board.style.gap = "0px";
            board.style.border = "green 2px solid";
        }

        if (alert) {
            alert.style.display = "block";
            alert.style.backgroundColor = "rgba(0, 128, 0, 0.9)";
            alert.innerHTML = "<h1>Success!</h1><br><p>The numbers are correctly ordered. Now, let's tackle this riddle<br>(Examine the finished puzzle to read it).</p>";
        }

        const gameCanvas: GameCanvas = document.querySelector<GameCanvas>("game-canvas") as GameCanvas;
        gameCanvas.contentText = ["The puzzle is now complete! Now I need to solve the riddle on the puzzle, and did I just hear the bookcase click?"];

        setTimeout(() => {
            const modal: HTMLElement = this.shadowRoot?.querySelector<HTMLElement>(".modal") as HTMLElement;
            if (modal) {
                modal.style.display = "none";
            }
            if (alert) alert.style.display = "none";
        }, 2000);

        gameCanvas.requestUpdate();
    }
}